import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import buddhistEra from 'dayjs/plugin/buddhistEra'
import 'dayjs/locale/th'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(localizedFormat)
dayjs.extend(buddhistEra)

// ฟังก์ชันแปลง ค.ศ. เป็น พ.ศ.
const convertToBuddhistYear = (formatted, dayjsObj) => {
  const year = dayjsObj.year()
  const buddhistYear = year + 543
  return formatted.replace(year.toString(), buddhistYear.toString())
}

const momenttimethai = (data) => {
  return dayjs(data).tz('Asia/Bangkok').locale('th').format('LT')
}

const momentdatethai = (data) => {
  const result = dayjs(data).tz('Asia/Bangkok').locale('th').format('ll')
  // แปลง ค.ศ. เป็น พ.ศ.
  return convertToBuddhistYear(result, dayjs(data).tz('Asia/Bangkok'))
}

const momentdateen = (data) => {
  return dayjs(data).tz('Pacific/Kiritimati').locale('en').format('ll')
}

const momenttimethaiformnow = (data) => {
  return dayjs(dayjs(data).tz('Pacific/Kiritimati').format().replace(/T/g, ' ')).locale('th').fromNow()
}

const momenttimethaiformnowen = (data) => {
  return dayjs(dayjs(data).tz('Pacific/Kiritimati').format().replace(/T/g, ' ')).fromNow()
}

const momenttimestamp = () => {
  return dayjs().tz('America/Danmarkshavn').format().replace(/T/g, ' ').replace('Z', '')
}

const momentdatetimethai = (data) => {
  const dayjsObj = dayjs(data).tz('Pacific/Kiritimati').locale('th')
  const formatted = dayjsObj.format('llll')
  // แปลง ค.ศ. เป็น พ.ศ.
  const withBuddhistYear = convertToBuddhistYear(formatted, dayjsObj)
  return withBuddhistYear.split('เวลา')[0]
}

export default {
  momenttimethai,
  momentdatethai,
  momenttimethaiformnow,
  momenttimethaiformnowen,
  momenttimestamp,
  momentdatetimethai,
  momentdateen
}



// WEBPACK FOOTER //
// ./src/services/momentthai.js